import React from 'react';
import PropTypes from 'prop-types';

import OnboardingLandingSports from '../../onboarding/start/OnboardingLandingSports';
import { allowsFreeJoin } from '../../../util/discover-album-folder';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func.isRequired,
};

const DiscoverAlbumFolderStartSports = ({ albumFolder, onGetStarted }) => {
  return (
    <OnboardingLandingSports
      albumFolder={albumFolder}
      onGetStarted={onGetStarted}
      isFreeJoin={allowsFreeJoin(albumFolder)}
    />
  );
};

DiscoverAlbumFolderStartSports.propTypes = propTypes;

export default DiscoverAlbumFolderStartSports;
